module.exports = __webpack_public_path__ + "static/media/ios-mail.8de2881e.svg";